










































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import * as _ from "lodash";

import { inventoryCollection } from "../../db";
import { formatDate } from "../../utilities";

import axios from "axios";

import AppPrintReport from "@/components/app-print-report.vue";
import * as firebase from "firebase/app";

interface SpecCategory {
  title: string;
  specs: Spec[];
}

interface Spec {
  text: string;
  value: string;
  type: SpecType;
  prefix?: string;
  suffix?: string;
  rules: any;
  selectOptions?: string[];
  width?: SpecWidth;
}

enum SpecType {
  text,
  autocomplete,
  combobox,
  select,
  date,
  contact,
  categories,
  options,
  description,
  address, // not currently used
  expenses,
  receivedChecklist,
  salesReadyChecklist,
  images,
  videos,
  workToDo,
  banner,
  tags,
  other,
}

enum SpecWidth {
  default,
  wide,
}

@Component({
  components: {
    AppPrintReport,
  },
})
export default class InventoryEquipmentEdit extends Vue {
  @Getter inventory;

  private SpecType = SpecType;
  private SpecWidth = SpecWidth;

  private item: any = null;

  private activeTab = "info";
  private tabs = [
    {
      text: "Information",
      value: "info",
      specs: [
        {
          title: "Status",
          specs: [
            {
              text: "Stock #",
              value: "stockNumber",
              type: SpecType.text,
              rules: { required: true, numeric: true },
            },
            {
              text: "Banner",
              value: "banner",
              type: SpecType.banner,
            },
            {
              text: "Status",
              value: "status",
              type: SpecType.other,
            },
            {
              text: "Tags",
              value: "tags",
              type: SpecType.tags,
              width: SpecWidth.wide,
            },
            {
              text: "Categories",
              value: "categories",
              type: SpecType.categories,
              width: SpecWidth.wide,
            },
          ],
        },
        {
          title: "General",
          specs: [
            {
              text: "Name",
              value: "name",
              type: SpecType.other,
              rules: { required: true },
              width: SpecWidth.wide,
            },

            {
              text: "Odometer",
              value: "odometer",
              type: SpecType.text,
              rules: { numeric: true },
              suffix: "mi",
            },
            {
              text: "VIN",
              value: "vin",
              type: SpecType.other,
              rules: [
                (v) => {
                  const length = (v || "").length;
                  return (
                    length == 0 || length == 17 || "Should be 17 charaters"
                  );
                },
              ],
            },
            {
              text: "Year",
              value: "year",
              type: SpecType.select,
              rules: { required: false },
              selectOptions: _.range(1960, new Date().getFullYear() + 1)
                .map((x) => x.toString())
                .concat("")
                .reverse(),
            },
            {
              text: "Make",
              value: "make",
              type: SpecType.combobox,
              rules: { required: true },
            },
            {
              text: "Model",
              value: "model",
              type: SpecType.combobox,
              rules: { required: true },
            },
            {
              text: "Series",
              value: "series",
              type: SpecType.combobox,
              rules: { required: false },
            },
            {
              text: "GVWR",
              value: "gvwr",
              type: SpecType.text,
              rules: { required: false },
            },
            {
              text: "GVWR Class",
              value: "gvwrClass",
              type: SpecType.text,
              rules: { required: false },
            },
            {
              text: "Options",
              value: "options",
              type: SpecType.options,
              width: SpecWidth.wide,
            },
            {
              text: "Description",
              value: "comments",
              type: SpecType.description,
              width: SpecWidth.wide,
            },
          ],
        },
        {
          title: "Engine",
          specs: [
            {
              text: "Engine Manufacturer",
              value: "engineManufacturer",
              type: SpecType.combobox,
              rules: { required: false },
            },
            {
              text: "Engine Model",
              value: "engineModel",
              type: SpecType.combobox,
              rules: { required: false },
            },
            {
              text: "Engine Liters",
              value: "engineLiters",
              type: SpecType.text,
              rules: { required: false },
            },
            {
              text: "Engine HP",
              value: "engineHP",
              type: SpecType.text,
              rules: { required: false },
            },
            {
              text: "Engine Cylinders",
              value: "engineCylinders",
              type: SpecType.text,
              rules: { required: false, numeric: true },
            },
            {
              text: "Fuel Type",
              value: "fuelType",
              type: SpecType.select,
              selectOptions: ["", "Diesel", "Gasoline"],
              rules: { required: false },
            },
          ],
        },
        {
          title: "Drive Train",
          specs: [
            {
              text: "Wheel Base",
              value: "wheelBase",
              type: SpecType.text,
              rules: { required: false, numeric: true },
              suffix: "inches",
            },
            {
              text: "Brake Type",
              value: "brakeType",
              type: SpecType.select,
              selectOptions: ["", "Hydraulic", "Air", "Electric", "Other"],
              rules: { required: false },
            },
            {
              text: "Transmission Manufacturer",
              value: "transmissionManufacturer",
              type: SpecType.combobox,
              rules: { required: false },
            },
            {
              text: "Transmission",
              value: "transmission",
              type: SpecType.combobox,
              rules: { required: false },
            }, // autocomplete ?
            {
              text: "Drive Type",
              value: "driveType",
              type: SpecType.combobox,
              rules: { required: false },
            },
            {
              text: "Rear Axle",
              value: "rearAxle",
              type: SpecType.select,
              selectOptions: ["", "SRW", "DRW"],
              rules: { required: false },
            },
            {
              text: "Number Rear Axles",
              value: "numberRearAxles",
              type: SpecType.text,
              rules: { required: false, numeric: true },
            },
            {
              text: "Front Tire Size",
              value: "frontTireSize",
              type: SpecType.text,
              rules: { required: false },
            },
            {
              text: "Rear Tire Size",
              value: "rearTireSize",
              type: SpecType.text,
              rules: { required: false },
            },
            {
              text: "Suspension",
              value: "suspension",
              type: SpecType.select,
              selectOptions: ["", "Air", "Beam", "Spring", "Other"],
              rules: { required: false },
            },
            {
              text: "Rear End Ratio",
              value: "rearEndRatio",
              type: SpecType.text,
              rules: { required: false },
            },
          ],
        },
        {
          title: "Other",
          specs: [
            {
              text: "Bed Dimensions",
              value: "bedDimensions",
              type: SpecType.text,
              rules: { required: false },
            },
            {
              text: "Exterior Color",
              value: "colorExterior",
              type: SpecType.text,
              rules: { required: false },
            },
            {
              text: "Interior Color",
              value: "colorInterior",
              type: SpecType.text,
              rules: { required: false },
            },
          ],
        },
      ],
    },
    {
      text: "Media",
      value: "media",
      specs: [
        {
          title: "Images",
          specs: [
            {
              text: "Images",
              value: "images",
              type: SpecType.images,
              width: SpecWidth.wide,
            },
          ],
        },
        {
          title: "Videos",
          specs: [
            {
              text: "Videos",
              value: "videos",
              type: SpecType.videos,
              width: SpecWidth.wide,
            },
          ],
        },
      ],
    },
    {
      text: "Financials",
      value: "financials",
      specs: [
        {
          title: "General",
          specs: [
            {
              text: "Current Price",
              value: "price",
              type: SpecType.text,
              rules: { numeric: true },
              prefix: "$",
            },
            {
              text: "Original List Price",
              value: "priceOrginal",
              type: SpecType.text,
              rules: { numeric: true },
              prefix: "$",
            },
          ],
        },
        {
          title: "Purchase Info",
          specs: [
            {
              text: "Purchased From",
              value: "purchaseCustomer",
              type: SpecType.contact,
            },
            {
              text: "Purchase Date",
              value: "purchaseDate",
              type: SpecType.date,
            },
            {
              text: "Purchase Price",
              value: "purchasePrice",
              type: SpecType.text,
              rules: { numeric: true },
              prefix: "$",
            },
            {
              text: "Expenses",
              type: SpecType.expenses,
              width: SpecWidth.wide,
            },
          ],
        },
        {
          title: "Sold Info",
          specs: [
            {
              text: "Customer",
              value: "soldCustomer",
              type: SpecType.contact,
            },
            {
              text: "Sold Date",
              value: "soldDate",
              type: SpecType.date,
            },
            {
              text: "Sold Price",
              value: "soldPrice",
              type: SpecType.text,
              rules: { numeric: true },
              prefix: "$",
            },
          ],
        },
      ],
    },
    {
      text: "Received",
      value: "receivedChecklist",
      specs: [
        {
          title: "Received",
          specs: [
            {
              text: "Received Checklist",
              value: "receivedChecklist",
              type: SpecType.receivedChecklist,
              width: SpecWidth.wide,
            },
          ],
        },
      ],
    },
    {
      text: "Work To Do",
      value: "workToDo",
      specs: [
        {
          title: "Work To Do",
          specs: [
            {
              text: "Work To Do",
              value: "workToDo",
              type: SpecType.workToDo,
              width: SpecWidth.wide,
            },
          ],
        },
      ],
    },

    {
      text: "Sales Ready",
      value: "salesReadyChecklist",
      specs: [
        {
          title: "Sales Ready Checklist",
          specs: [
            {
              text: "Sales Ready Checklist",
              value: "salesReadyChecklist",
              type: SpecType.salesReadyChecklist,
              width: SpecWidth.wide,
            },
          ],
        },
      ],
    },
  ];

  private menu = {};
  private formatDate = formatDate;

  private stroageName = "edit";
  private storageData = {
    activeTab: "info",
  };

  created() {
    this.openStorage();
  }

  openStorage() {
    const result = JSON.parse(localStorage.getItem(this.stroageName) || "{}");
    const fields = ["activeTab"];
    fields.forEach((x) => {
      this.updateStorageData(x, result);
    });
  }

  updateStorageData(field, data) {
    if (data[field]) {
      this.storageData[field] = data[field];
    }
  }

  saveStorage() {
    localStorage.setItem(this.stroageName, JSON.stringify(this.storageData));
  }

  private breadcrumbs: any[] = [];

  async buildName() {
    this.item.name = [this.item.year, this.item.make, this.item.model]
      .join(" ")
      .trim();

    await this.summit("name");
  }

  async buildDescription() {
    this.item.comments = [
      this.item.name,
      this.item.options.join(", ").trim(),
      `GVWR ${this.numberWithCommas(this.item.gvwr)} Lbs`,
      `Mileage ${this.numberWithCommas(this.item.odometer)} Miles`,
    ]
      .join(", ")
      .trim();
    await this.summit("comments");
  }
  numberWithCommas(x): string {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  async processVin() {
    const response = await axios.get(
      `https://vpic.nhtsa.dot.gov/api/vehicles/decodevinvaluesextended/${this.item.vin.trim()}?format=json`
    );
    // Read the result field from the JSON response.
    if (response.data.Results.length > 0) {
      const vinData = response.data.Results[0];

      const newData = {
        year: parseInt(vinData.ModelYear, 10),
        make: vinData.Make,
        model: vinData.Model,
        series: vinData.Series,
        engineManufacturer: vinData.EngineManufacturer,
        engineModel: vinData.EngineModel,
        engineCylinders: vinData.EngineCylinders,
        engineHP: vinData.EngineHP,
        engineLiters: Math.round(vinData.DisplacementL * 10) / 10,
        fuelType: vinData.FuelTypePrimary,
        gvwrClass: vinData.GVWR.replace(/\(.+\)/, "").trim(),
        driveType: vinData.DriveType,
        brakeType: vinData.BrakeSystemType,
      };

      // TODO: can't update item, should work but doesn't, can save and it will though
      for (const key in newData) {
        if (newData[key] != "") {
          if (this.item[key] != newData[key]) {
            // when updating via the bracket syntax, you must use Vue.set to trigger the reactivity.
            Vue.set(this.item, key, newData[key].toString());
            this.summit(key);
          }
        }
      }
    }
  }

  @Watch("inventory", { immediate: true })
  async inventoryUpdated() {
    // wait for inventory to load with data
    if (this.inventory.length == 0) {
      return;
    }

    const stockNumber = this.$route.params.name;

    const items = this.inventory.filter((x) => x.stockNumber == stockNumber);

    // if not items found, redirect to inventory
    if (items.length == 0) {
      return;
    }
    this.item = items[0];

    this.breadcrumbs = [
      { text: "Inventory", disabled: false, href: "/" },
      { text: this.item.name, href: `/inventory/${this.item.stockNumber}` },
      { text: "edit", disabled: true },
    ];
  }

  async summit(value) {
    const obj = {};
    if (this.item[value] != undefined) {
      obj[value] = this.item[value];
    } else {
      obj[value] = firebase.firestore.FieldValue.delete();
    }
    await inventoryCollection.doc(`${this.item.id}`).update(obj);
  }

  private autocomplete(value: string) {
    return _.sortBy(
      _.uniq(this.inventory.map((x) => x[value]).filter((x) => x !== undefined))
    );
  }
}
